import { Controller } from '@hotwired/stimulus';

export default class EnglishName extends Controller {
  static targets = [
    'checkbox',
    'englishName'
  ];

  checkboxChanged() {
    this.englishNameTarget.disabled = !this.checkboxTarget.checked;
  }
}
